exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-container[data-v-db4b2238]{position:relative}img.wish-hearth[data-v-db4b2238]{width:35px;height:35px;position:absolute;top:10px;right:10px;cursor:pointer;z-index:1}", ""]);

// exports
